import useAnalytics from "hooks/analytics";
import React, { useState } from "react";
import { ChevronDown, User } from "react-feather";
import { useHistory } from "react-router-dom";
import { Popover } from "../";
import logoSrc from "../../assets/images/logo.svg";
import useAuthToken from "../../hooks/auth-token";
import useAuthUser from "../../hooks/auth-user";
import useLanguage from "../../hooks/language";
import useScroll from "../../hooks/scroll";
import ROUTES from "../../utils/routes";
import { LanguagePicker } from "../index";
import styles from "./header.module.css";

const PRELIB_WEBSITE_URL = "https://www.prelib.com";

type HeaderProps = {
    /** Stay transparent/inherited (grey on booking flow) — no white bar on scroll. */
    matchPageBackground?: boolean;
};

const Header: React.FunctionComponent<HeaderProps> = ({
    matchPageBackground = false,
}) => {
    const [authUser] = useAuthUser();
    const setAuthToken = useAuthToken()[1];
    const { scrollY } = useScroll();
    const { push } = useHistory();
    const { translations } = useLanguage();
    const t = translations.homePage.topMenu;
    const [analytics] = useAnalytics();

    // State

    const [popoverShown, setPopoverShown] = useState(false);
    const onSignOut = () => {
        analytics?.cdp()?.disconnectUser();

        setAuthToken(null);

        push(ROUTES.LOGIN);
    };

    const renderUserButton = () => {
        if (!authUser) return;
        return (
            <div style={{ position: "relative" }}>
                <button
                    className={styles.profileButton}
                    onClick={() => setPopoverShown(!popoverShown)}
                >
                    <div>
                        <User />
                    </div>
                    <span className={styles.desktopOnly}>
                        {authUser.firstName}
                    </span>
                    <ChevronDown />
                </button>
                <Popover
                    align="right"
                    position="bottom"
                    shown={popoverShown}
                    onChange={setPopoverShown}
                >
                    <div className={styles.popoverContent}>
                        <button onClick={() => push(ROUTES.PROFILE)}>
                            {t.updateProfile}
                        </button>
                        <button className="danger" onClick={onSignOut}>
                            {t.disconnectButtonText}
                        </button>
                    </div>
                </Popover>
            </div>
        );
    };

    return (
        <div
            className={`${styles.header} ${
                !matchPageBackground && scrollY > 50 ? styles.bgWhite : ""
            }`}
        >
            <a href={authUser ? ROUTES.HOME : PRELIB_WEBSITE_URL}>
                <img className={styles.logo} src={logoSrc} />
            </a>
            <div>
                <LanguagePicker />
                {authUser && renderUserButton()}
            </div>
        </div>
    );
};

export default Header;
